<template>
  <div data-carousel="chevron" class="carousel-chevron">
    <a data-carousel="chevron-left" class="arrow-left effect-black" href>
      <svg
        viewBox="0 0 24 24"
        preserveAspectRatio="xMidYMid meet"
        focusable="false"
        size="icon-sm"
        class="icon"
        icon-size="icon-lg"
        style="pointer-events: none; display: block;"
      >
        <g
          id="icon-narrow-angle-left-24"
          stroke="none"
          stroke-width="1"
          fill="none"
          fill-rule="evenodd"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <g transform="translate(-196, -226)" stroke="currentColor">
            <polyline
              transform="translate(209.000000, 237.500000) scale(-1.2, 1.2) rotate(90.000000) translate(-209.000000, -237.500000) "
              points="200 242 209 233 218 242"
            />
          </g>
        </g>
      </svg>
    </a>
    <a data-carousel="chevron-right" class="arrow-right effect-black" href>
      <svg
        viewBox="0 0 24 24"
        preserveAspectRatio="xMidYMid meet"
        focusable="false"
        size="icon-sm"
        class="icon"
        icon-size="icon-lg"
        style="pointer-events: none; display: block;"
      >
        <g
          id="icon-narrow-angle-right-24"
          stroke="none"
          stroke-width="1"
          fill="none"
          fill-rule="evenodd"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <g transform="translate(-196, -226)" stroke="currentColor">
            <polyline
              transform="translate(209.000000, 237.500000) scale(-1.2, 1.2) rotate(-90.000000) translate(-209.000000, -237.500000) "
              points="200 242 209 233 218 242"
            />
          </g>
        </g>
      </svg>
    </a>
  </div>
</template>
<script>
export default {
  name: "CarouselChevron"
};
</script>
<style lang="scss">
.carousel-chevron {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;

  .arrow-left,
  .arrow-right {
    height: auto;
    width: auto;
    padding: 10px;
    border: 2px solid black;
    border-radius: 3px;
    cursor: pointer;
    color: inherit !important;

    svg {
      height: 20px;
      width: 20px;

      &:hover {
        fill: var(--theme__color3);
        color: var(--theme__color3);
      }
    }
  }
}
</style>
